import React from "react";
import { motion } from "framer-motion";
import { Section, SectionHeader } from "@/components/Section";
import { AlertTriangle, CalendarClock, Clock, CreditCard } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const POLICIES = [
  {
    icon: CreditCard,
    title: "Advance payment",
    body: "Payment is required in advance and is non-refundable, but it is transferrable to a friend or family member.",
  },
  {
    icon: CalendarClock,
    title: "Class notice",
    body: "Need 3 to 5 days notice in advance for the class.",
  },
  {
    icon: Clock,
    title: "Cancellation notice",
    body: "Give 24 hrs notice to cancel the class otherwise charge may be in full except for emergency.",
  },
  {
    icon: AlertTriangle,
    title: "Timing and no-shows",
    body: "Be punctual. Late arrivals will result in shortened lesson time. No-show or late cancellation may be charged in full.",
  },
  {
    icon: AlertTriangle,
    title: "Traffic or emergency delays",
    body: "Lesson might get 15-30 minutes late or cancel due to adverse conditions, traffic congestion, or emergency situation.",
  },
];

export const BookingPolicies = () => {
  return (
    <Section id="policies" testId="section-booking-policies" className="bg-white/35">
      <SectionHeader
        kicker="Booking Policies"
        title="Important terms before you book."
        subtitle="A few scheduling and payment rules to keep lessons fair, organized, and on time."
        testId="booking-policies-header"
      />

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {POLICIES.map((policy, i) => (
          <motion.article
            key={policy.title}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.45, delay: i * 0.05, ease: EASE }}
            className="rounded-2xl glass-card p-5 sm:p-6"
          >
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-maple-tan2/10 text-maple-tan2">
              <policy.icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-serif text-xl text-maple-navy leading-tight">
              {policy.title}
            </h3>
            <p className="mt-2 text-sm text-maple-navy/75 leading-relaxed">
              {policy.body}
            </p>
          </motion.article>
        ))}
      </div>
    </Section>
  );
};
